import { combineReducers } from 'redux'

import orders from './orders/reducer'
import products from './products/reducer'

export default combineReducers({
  orders,
  products,
})
